import { render } from "./InitialCapital.vue?vue&type=template&id=3ac72b3f"
import script from "./InitialCapital.vue?vue&type=script&lang=js"
export * from "./InitialCapital.vue?vue&type=script&lang=js"

import exportComponent from "/home/artur/code/vue/zinzeszinsapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__